// src/utils/auth.js
import {jwtDecode} from 'jwt-decode';

export const isTokenValid = () => {
  const token = localStorage.getItem('access_token');
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (e) {
    return false;
  }
};
